
import Api from '../../../helpers/Api';

/*
*IMPORTANT: this is the albums of the moment component, nothing specific to any artist!
*It might make sense to make this a standalone component, to logically seperate it better...
*/


export const SET_DATA_ALBUMS_SLIDER = 'SET_DATA_ALBUMS_SLIDER';
const setDataAlbumsSlider = (albumSlides) => ({
    type: SET_DATA_ALBUMS_SLIDER,
    albumSlides,
});

// ACTIONS

export const fetchAlbumSlidesIfNeeded = (limit = 20) => (dispatch, getState) => {
    // Note: The controller randomizes the albums every day and returns only the requested number of albums
    // We have 17 albums in DB so far, we can have some issues if the quantity pass the limit set.
    const albumSlides = getState().artists.AlbumsSlider.albumSlides;

    if (albumSlides.length < 1) {
        return Api.progressGet(dispatch, `/api/v1/artists/getAlbumsDoMomento/${limit}`)
            // The  returned album order is randomized by the api.
            .then((json) => {
                if (json.status === 'success') {
                    return dispatch(setDataAlbumsSlider(json.data));
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('fetchAlbumSlidesIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};
